import { LOCALES } from '@marketplace/i18n';

export const appStatusI18n = {
  [LOCALES.ENG]: {
    app_status_current_status: 'STATUS',
    app_status_modified: 'MODIFIED',
    app_status_categories: 'CATEGORIES',
    app_status_products: 'PLATFORMS',
    app_status_purposes: 'PURPOSES',
    app_status_users: 'USERS',
  },
};